import { useEffect, useState } from "react";
import DateField from "../../components/shared/DateField";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import PageMain from "../../containers/shared/PageMain";
import apiClientFiles from "../../components/utils/apiClientFiles";
import moment from "moment";
import ReportsBar from "../../components/reports/ReportsBar";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import Toast from "../../components/shared/Toast";
import apiClient from "../../components/utils/apiClient";
import { Link } from "react-router-dom";
import Pagination from "../../components/shared/Pagination";

const ReportsHomePage = () => {

    const pageTitle = {title: 'التقارير', subTitle: 'يمكنك إصدار كافة التقارير من هنا'};
    useDocumentTitle('التقارير');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [showDropDown, setShowDropDown] = useState(false);
    const [reports, setReports] = useState(null);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(true);

    const [toast, setToast] = useState({show: false,type: null, message:'' });

    const [pageSize, setPageSize] = useState(20);
    const [currentPage,setCurrentPage] = useState(1);
    const [total,setTotal] = useState(0);
    const [currentCount,setCurrentCount] = useState(0);
    const [hasMore,setHasMore] = useState(true);
    const [showDownloadMenu, setShowDownloadMenu] = useState(false);

    const handleDownloadReport = async (reportType,downloadLabel) => {
        if(!startDate || !endDate) {
            setToast({show:true,type:'error',message:'من فضلك اختر الفتره اولا'});
            return;
        } 
        if (moment(startDate).isAfter(moment(endDate))) {
            setToast({show:true,type:'error',message:'يجب اختيار تاريخ النهاية بعد تاريخ البداية'});
            return;
        }
        setShowDownloadModal(downloadLabel);
        setIsDownloading(true);
        DownloadReportAction(reportType);
        // setToast({show:true,type:'error',message:'حدث خطأ, يرجى المحاوله مرة أخرى لاحقاً'});
    }

    const getAllReposts = async (page=1) => {
        try {
          const response = await apiClient.get(`/b-reports/all-reports?skip=${(page-1)*pageSize}&limit=${pageSize}`);
          if(response?.data) {
              setIsDownloading(false);
              setReports(response?.data);
              if(response?.data?.length > 0) {
                setCurrentCount(response?.data?.length);
                setCurrentPage(page);
                if(response?.data?.length === pageSize) {
                    setHasMore(true);
                }
            } else {
                setHasMore(false);
            }
          } else {

          }
        } catch(err) {
            
        }
    }

    useEffect(()=>{
        getAllReposts();
    },[])


    const DownloadReportAction = async (url) => {
        const startDatefinal = startDate ? moment(startDate).locale('en').format('YYYY/MM/DD') : null;
        const endDatefinal = endDate ? moment(endDate).locale('en').format('YYYY/MM/DD') : null;
        try {
          const response = await apiClientFiles.get(`${url}${startDatefinal && endDatefinal ? `?dateFrom=${startDatefinal}&dateTo=${endDatefinal}` : ''}`);
          if(response.data) {
            //   let fileURL = URL.createObjectURL(response.data);
            //   let fileLink = document.createElement('a');
            //   fileLink.href = fileURL;
            //   fileLink.download = 'report-requests-summary';
            //   fileLink.click();
            getAllReposts();
          } else {
          }
        } catch(err) {
            setToast({show:true,type:'error',message:err?.response?.data?.message});
            setIsDownloading(false);
            setShowDownloadModal(false);
        }
    }

    const closeDownloadModal = () => {
        setShowDownloadModal(false);
        setIsDownloading(true);
    }

    const handleChangePageAction = (page) => {
      getAllReposts(page);
    }

    

    // const DownloadUnitsDetailedRequests = async () => {
    //     const startDatefinal = startDate ? moment(startDate).locale('en').format('YYYY/MM/DD') : null;
    //     const endDatefinal = endDate ? moment(endDate).locale('en').format('YYYY/MM/DD') : null;
    //     try {
    //       const response = await apiClientFiles.get(`/b-reports/units-detailed-requests${startDatefinal && endDatefinal ? `?dateFrom=${startDatefinal}&dateTo=${endDatefinal}` : ''}`,{
    //           responseType: 'blob',
    //         });
    //       if(response.data) {
    //           let fileURL = URL.createObjectURL(response.data);
    //           let fileLink = document.createElement('a');
    //           fileLink.href = fileURL;
    //           fileLink.download = 'report-units-detailed-requests';
    //           fileLink.click();
    //       } else {
    //       }
    //     } catch(err) {}
    // }

    // const DownloadUnitsExpenseDetailed = async () => {
    //     const startDatefinal = startDate ? moment(startDate).locale('en').format('YYYY/MM/DD') : null;
    //     const endDatefinal = endDate ? moment(endDate).locale('en').format('YYYY/MM/DD') : null;
    //     try {
    //       const response = await apiClientFiles.get(`/b-reports/units-expense-detailed${startDatefinal && endDatefinal ? `?dateFrom=${startDatefinal}&dateTo=${endDatefinal}` : ''}`,{
    //           responseType: 'blob',
    //         });
    //       if(response.data) {
    //           let fileURL = URL.createObjectURL(response.data);
    //           let fileLink = document.createElement('a');
    //           fileLink.href = fileURL;
    //           fileLink.download = 'report-units-expense-detailed';
    //           fileLink.click();
    //       } else {
    //       }
    //     } catch(err) {}
    // }

    // const DownloadUnitsPreventiveVisits = async () => {
    //     const startDatefinal = startDate ? moment(startDate).locale('en').format('YYYY/MM/DD') : null;
    //     const endDatefinal = endDate ? moment(endDate).locale('en').format('YYYY/MM/DD') : null;
    //     try {
    //       const response = await apiClientFiles.get(`/b-reports/units-preventive-visits${startDatefinal && endDatefinal ? `?dateFrom=${startDatefinal}&dateTo=${endDatefinal}` : ''}`,{
    //           responseType: 'blob',
    //         });
    //       if(response.data) {
    //           let fileURL = URL.createObjectURL(response.data);
    //           let fileLink = document.createElement('a');
    //           fileLink.href = fileURL;
    //           fileLink.download = 'report-units-preventive-visits';
    //           fileLink.click();
    //       } else {
    //       }
    //     } catch(err) {}
    // }

    // const DownloadPropertyPerformance = async () => {
    //     const startDatefinal = startDate ? moment(startDate).locale('en').format('YYYY/MM/DD') : null;
    //     const endDatefinal = endDate ? moment(endDate).locale('en').format('YYYY/MM/DD') : null;
    //     try {
    //       const response = await apiClientFiles.get(`/b-reports/property-performance${startDatefinal && endDatefinal ? `?dateFrom=${startDatefinal}&dateTo=${endDatefinal}` : ''}`,{
    //           responseType: 'blob',
    //         });
    //       if(response.data) {
    //           let fileURL = URL.createObjectURL(response.data);
    //           let fileLink = document.createElement('a');
    //           fileLink.href = fileURL;
    //           fileLink.download = 'report-property-performance';
    //           fileLink.click();
    //       } else {
    //       }
    //     } catch(err) {}
    // }

    const handleDownloadReportAction = async (url) => {
        if(!url) return;
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', 'download');
        link.setAttribute('target', '_blank');

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);

        setShowDownloadMenu(false);
    }


    return (
        <>
        <div>
                <PageHeader pageTitle={pageTitle} />
                <PageMain>
                    <div className="fixed top-0 left-0 w-full h-full bg-grey-50 z-[-1]"></div>
                    <MainContent>

                        <ReportsBar reportsCount={reports?.length} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} handleDownloadReport={handleDownloadReport} setShowDropDown={setShowDropDown} showDropDown={showDropDown} />

                        {reports && Array.isArray(reports) && reports?.length > 0 ?
                        <><table className="w-full mt-[25px]">
                            <thead>
                                <tr className="border-b-[2px] border-b-grey-50">
                                    <th className="bg-white leading-[56px] rounded-ss-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">التقرير</th>
                                    <th className="bg-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 w-[170px]">انشئ بواسطة</th>
                                    <th className="bg-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 w-[170px]">من تاريخ</th>
                                    <th className="bg-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 w-[170px]">الى تاريخ</th>
                                    <th className="bg-white leading-[56px] text-center px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100 w-[170px]">الحالة</th>
                                    <th className="bg-white leading-[56px] rounded-se-[8px] text-center px-[15px] text-[16px] font-[500px] w-[128px]">التحميل</th>
                                </tr>
                            </thead>
                            <tbody>
                        {reports?.map((report,index)=>{
                            return (
                                <tr key={`report-${index}`} className="border-t-[1px] border-t-grey-200 leading-[68px] bg-white">
                                    <td className="px-[12px] font-[500] text-[14px] text-grey-900">{report?.reportName}</td>
                                    <td className="px-[12px] font-[500] text-[14px] text-grey-900">{report?.createdBy?.name}</td>
                                    <td className="px-[12px] font-[500] text-[14px] text-grey-900">{moment(report?.dateFrom).format('DD MMM YYYY')}</td>
                                    <td className="px-[12px] font-[500] text-[14px] text-grey-900">{moment(report?.dateTo).format('DD MMM YYYY')}</td>
                                    <td className="px-[12px] font-[600] text-[14px] text-success text-center">جاهز</td>
                                    <td className="px-[12px] font-[500] text-[14px] text-grey-900 text-center">
                                        <div className="relative">
                                            <div className="inline-block w-[24px] h-[24px] cursor-pointer" style={{background: "url('/assets/images/import.svg')"}} onClick={()=> showDownloadMenu === index+1 ? setShowDownloadMenu(false) : setShowDownloadMenu(index+1)}></div>
                                            {showDownloadMenu === index+1 ? <div className="absolute top-[69px] start-[10px] bg-white rounded-b-[8px] shadow-[0px_25px_35px_0px_rgba(0,0,0,0.03)] border-[1px] border-grey-300 w-[89px] px-[12px] py-[8px] z-[20]">
                                                <div className=" h-[48px] leading-[48px] text-start px-[8px] py-[12px] flex flex-nowrap justify-between items-center cursor-pointer select-none" onClick={()=>handleDownloadReportAction(report?.reportFile?.pdfUrl)}>
                                                    <div className="w-[80%] text-[16px] text-grey-[600] font-[500]">
                                                    Pdf
                                                    </div>
                                                    <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[6px] text-end">
                                                        <path d="M4.27752 8.5575C4.46752 8.5575 4.65752 8.4875 4.80752 8.3375C5.09752 8.0475 5.09752 7.5675 4.80752 7.2775L1.80752 4.2775L4.80752 1.2775C5.09752 0.9875 5.09752 0.5075 4.80752 0.2175C4.51752 -0.0725 4.03752 -0.0725 3.74752 0.2175L0.217524 3.7475C-0.0724759 4.0375 -0.0724759 4.5175 0.217524 4.8075L3.74752 8.3375C3.89752 8.4875 4.08752 8.5575 4.27752 8.5575Z" fill="#94A3B8"/>
                                                    </svg>
                                                </div>
                                                <div className="h-[1px] my-[4px] bg-grey-200"></div>
                                                <div className=" h-[48px] leading-[48px] text-start px-[8px] py-[12px] flex flex-nowrap justify-between items-center cursor-pointer select-none" onClick={()=>handleDownloadReportAction(report?.reportFile?.excelUrl)}>
                                                    <div className="w-[80%] text-[16px] text-grey-[600] font-[500]">
                                                    Xls
                                                    </div>
                                                    <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[6px] text-end">
                                                        <path d="M4.27752 8.5575C4.46752 8.5575 4.65752 8.4875 4.80752 8.3375C5.09752 8.0475 5.09752 7.5675 4.80752 7.2775L1.80752 4.2775L4.80752 1.2775C5.09752 0.9875 5.09752 0.5075 4.80752 0.2175C4.51752 -0.0725 4.03752 -0.0725 3.74752 0.2175L0.217524 3.7475C-0.0724759 4.0375 -0.0724759 4.5175 0.217524 4.8075L3.74752 8.3375C3.89752 8.4875 4.08752 8.5575 4.27752 8.5575Z" fill="#94A3B8"/>
                                                    </svg>
                                                </div>
                                            </div> : ''}
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                        </table>
                        <Pagination label={'تقارير'} currentCount={currentCount} currentPage={currentPage} pageSize={pageSize} handleClickChangePage={page => handleChangePageAction(page)} hasMore={hasMore} />
                        </>
                        :
                        <div className="pt-[80px] text-center">
                            <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/note.svg')"}}></div>
                            <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لم يتم طلب أي تقرير حتى الآن</div>
                            <div className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600] cursor-pointer" onClick={()=> setShowDropDown(true)}>طلب تقرير جديد</div>
                        </div>}

                        {/* <div className="">
                            <label className="mb-[5px] block">اختر الفترة المطلوبة:</label>
                            <div className="inline-block ms-[10px]">
                                <DateField label={'تاريخ البداية'} placeholder={'اختر تاريخ البداية'} value={startDate} error={''} errorMessage={''} translateError={true} onChange={(date)=>{ setStartDate(date)}} />
                                
                            </div>
                            <div className="inline-block ms-[10px]">
                                <DateField label={'تاريخ النهاية'} placeholder={'اختر تاريخ النهاية'} value={endDate} error={''} errorMessage={''} translateError={true} onChange={(date)=>{ setEndDate(date)}} />
                                
                            </div>
                        </div>

                        <div className="mt-[15px]">
                            <label className="mb-[5px] block">اختر التقرير المطلوب:</label><br />
                            <div className="me-[5px] inline-block bg-white text-blue text-center px-[15px] leading-[35px] font-bold h-[40px] cursor-pointer rounded-[8px] border-[2px] border-blue" onClick={()=>DownloadRequestsSummary()}>ملخص الطلبات</div>
                            <div className="me-[5px] inline-block bg-white text-blue text-center px-[15px] leading-[35px] font-bold h-[40px] cursor-pointer rounded-[8px] border-[2px] border-blue" onClick={()=>DownloadUnitsDetailedRequests()}>طلبات الوحدات التفصيلية</div>
                            <div className="me-[5px] inline-block bg-white text-blue text-center px-[15px] leading-[35px] font-bold h-[40px] cursor-pointer rounded-[8px] border-[2px] border-blue" onClick={()=>DownloadUnitsExpenseDetailed()}>نفقات الوحدات التفصيلية</div>
                            <div className="me-[5px] inline-block bg-white text-blue text-center px-[15px] leading-[35px] font-bold h-[40px] cursor-pointer rounded-[8px] border-[2px] border-blue" onClick={()=>DownloadUnitsPreventiveVisits()}>وحدات الصيانة الوقائية</div>
                            <div className="me-[5px] inline-block bg-white text-blue text-center px-[15px] leading-[35px] font-bold h-[40px] cursor-pointer rounded-[8px] border-[2px] border-blue" onClick={()=>DownloadPropertyPerformance()}>اداء المنشأت</div>
                        </div> */}

                    </MainContent>
                </PageMain>
                <Toast toast={toast} setToast={setToast} />

                <div className={`w-full max-w-[400px] h-[123px] fixed bottom-0 end-[25px] transform-gpu duration-300 transition-transform ${showDownloadModal ? 'translate-y-[0]' : 'translate-y-[123px]'}`}>
                <div className="w-full h-[51px] bg-grey-100 rounded-t-[8px] leading-[51px] font-[700] text-grey-900 text-[18px] relative px-[15px]">
                    {isDownloading ? `تجهيز التقرير للتحميل` : `تم التحميل بنجاح`} 
                    <img src="/assets/images/close-download.svg" alt="" className=" absolute w-[24px] h-[24px] end-[15px] top-[13px] cursor-pointer" onClick={()=>closeDownloadModal()} />
                </div>
                <div className="w-full h-[72px] bg-white px-[15px] py-[24px] font-[500] text-grey-900 text-[14px] relative">
                    <img src={`/assets/images/document-${isDownloading ? `not-` : ''}download.svg`} alt="" className="w-[20px] h-[20px] inline-block me-[3px]" />
                    {showDownloadModal}

                    <img src={`/assets/images/${isDownloading? `download-loading.svg` : `tick-circle.svg`}`} alt="" className={`${isDownloading ? 'animate-spin' : ''} absolute w-[24px] h-[24px] top-[24px] end-[15px]`} />
                </div>
            </div>
        </div>
        </>
    )
}

export default ReportsHomePage;